import { useFormik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { addUserAdmin, editUserAdmin, getSingleUserAdmin } from "../../redux/services/userAdminSlice";
import { ROUTES } from "../../constant";
import { Select } from "antd";
import { MENU_LABELS } from "../../constant/Menu_Labels";

// const accessOptions = [
//     { label: "Dashboard", value: "dashboard" },
//     { label: "Courses", value: "courses" },
//     { label: "Workshops", value: "workshops" },
//     { label: "Website", value: "website" },
//     { label: "Students", value: "students" },
//     { label: "Admins", value: "admins" },
// ];

const UserAdminForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const singleUser = useSelector(
        (state) => state.userAdmin.singleUserAdminData
    );

    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get("userId");

    const [loading, setLoading] = useState(false);

    const route = ROUTES.USER_ADMIN.BASE

    const initialValues = {
        firstName: "",
        lastName: "",
        designation: "",
        password: "",
        email: "",
        // contact: "",
        contact: {
            // countryCode: "+91",
            mobile: "",
        },
        access: ["dashboard"],
        userType: "telecaller",
    };

    const validationSchema = Yup.object({
        firstName: Yup.string().required("First Name is required"),
        lastName: Yup.string().required("Last Name is required"),
        designation: Yup.string().required("Designation is required"),
        password: Yup.string().required("Password is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        contact: Yup.object({
            mobile: Yup.string()
                .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
                .required("Mobile number is required"),
            // countryCode: Yup.string().required("Countrycode is required"),
        }),
        // mobile: Yup.string()
        //     .required("Mobile Number is required")
        //     .min(10, "Must be at least 10 digits"),
        access: Yup.array().min(1, "Select at least one access privilege"),
        // userType: Yup.string().required("userType is required"),
    });

    const onSubmit = async (values) => {
        setLoading(true);
        try {
            let response;
            if (userId) {
                response = await dispatch(editUserAdmin({ ...values, userId }));
            } else {
                response = await dispatch(addUserAdmin(values));
            }

            if (response?.payload?.status === 200) {
                toast.success(response?.payload?.message, {
                    autoClose: 2000,
                    pauseOnHover: false,
                });
                navigate(route);
                resetForm();
            }
        } catch (err) { }
        setLoading(false);
    };

    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setValues,
        resetForm,
    } = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    const getSingleRecord = useCallback(async () => {
        try {
            await dispatch(getSingleUserAdmin(userId));
        } catch (error) { }
    }, [dispatch, userId]);

    const handleSelectChange = (field, value) => {
        setValues((prev) => ({ ...prev, [field]: value }));
    };

    useEffect(() => {
        if (userId) {
            getSingleRecord();
        }
    }, [userId, getSingleRecord]);

    useEffect(() => {
        if (userId && singleUser) {
            setValues({
                firstName: singleUser?.firstName ?? "",
                lastName: singleUser?.lastName ?? "",
                designation: singleUser?.designation ?? "",
                email: singleUser?.email ?? "",
                // mobile: singleUser?.mobile ?? "",
                contact: {
                    countryCode: singleUser?.contact?.countryCode,
                    mobile: singleUser?.contact?.mobile,
                },
                password: singleUser?.password ?? "",
                access: singleUser?.access ?? [],
                userType: singleUser?.userType ?? "",
            });
        }
    }, [userId, singleUser, setValues]);


    const accessOptions = Object.values(MENU_LABELS);
    // console.log(accessOptions)

    return (
        <div>
            <div className="bg-background py-4 sm:py-4">
                <div className="px-4 md:py-10 py-5 bg-card shadow rounded-3xl sm:p-10">
                    <p className="md:text-3xl text-xl text-center font-medium uppercase text-primary">
                    User-Admin
                    </p>

                    <form className="mt-6 antForm" onSubmit={handleSubmit} >
                        <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
                            {/* First Name */}
                            <div>
                                <label className="text-sm font-medium text-foreground">First Name</label>
                                <input
                                    type="text"
                                    name="firstName"
                                    className="w-full px-4 py-2 border border-border rounded-xl"
                                    value={values.firstName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="First Name"
                                />
                                {touched.firstName && errors.firstName && (
                                    <div className="text-red-500 text-sm">{errors.firstName}</div>
                                )}
                            </div>

                            {/* Last Name */}
                            <div>
                                <label className="text-sm font-medium text-foreground">Last Name</label>
                                <input
                                    type="text"
                                    name="lastName"
                                    className="w-full px-4 py-2 border border-border rounded-xl"
                                    value={values.lastName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Last Name"
                                />
                                {touched.lastName && errors.lastName && (
                                    <div className="text-red-500 text-sm">{errors.lastName}</div>
                                )}
                            </div>

                            {/* Designation */}
                            <div>
                                <label className="text-sm font-medium text-foreground">
                                    Designation
                                </label>
                                <input
                                    type="text"
                                    name="designation"
                                    className="w-full px-4 py-2 border border-border rounded-xl"
                                    value={values.designation}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Designation"
                                />
                                {touched.designation && errors.designation && (
                                    <div className="text-red-500 text-sm">{errors.designation}</div>
                                )}
                            </div>

                            {/* Last Name */}
                            <div>
                                <label className="text-sm font-medium text-foreground">Password </label>
                                <input
                                    type="text"
                                    name="password"
                                    className="w-full px-4 py-2 border border-border rounded-xl"
                                    value={values.password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Password"
                                />
                                {touched.password && errors.password && (
                                    <div className="text-red-500 text-sm">{errors.password}</div>
                                )}
                            </div>


                            {/* Email */}
                            <div>
                                <label className="text-sm font-medium text-foreground">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    className="w-full px-4 py-2 border border-border rounded-xl"
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Email"
                                />
                                {touched.email && errors.email && (
                                    <div className="text-red-500 text-sm">{errors.email}</div>
                                )}
                            </div>

                            {/* Mobile Number */}

                            <div>
                                <label className="text-sm font-medium text-foreground">Contact</label>
                                <div className="flex space-x-2">
                                    {/* <div>
                                        <input type="text" name="contact.countryCode" className="w-full px-4 py-2 border border-border rounded-xl" value={values.contact.countryCode} onChange={handleChange} onBlur={handleBlur} placeholder="Country Code" />

                                        {touched.contact?.countryCode && errors.contact?.countryCode && <div className="text-red-500 text-sm">{errors.contact?.countryCode}</div>}
                                    </div> */}
                                    <div className="w-full">
                                        <input type="text" name="contact.mobile" className="w-full px-4 py-2 border border-border rounded-xl" value={values.contact.mobile} onChange={handleChange} onBlur={handleBlur} placeholder="Mobile Number" />
                                        {touched.contact?.mobile && errors.contact?.mobile && <div className="text-red-500 text-sm">{errors.contact?.mobile}</div>}
                                    </div>
                                </div>
                            </div>


                            {/* Multi Select - Access */}

                            <div className="w-full">
                                <label className="block font-medium mb-1">Access</label>
                                <Select
                                    mode="multiple"
                                    value={values.access}
                                    onChange={(v) => handleSelectChange("access", v)}
                                    // options={moduleData?.module_data?.map((m) => ({
                                    //     value: m._id,
                                    //     label: m.name,
                                    // }))}
                                    options={accessOptions}
                                    placeholder="Select Access"
                                    className="w-full!"
                                    style={{ width: "100%" }}
                                />
                                {errors.access && <p className="text-red-500 text-sm">{errors.access}</p>}
                            </div>

                        </div>

                        <div className="flex justify-center">
                            <button
                                type="submit"
                                className="w-full sm:w-[250px] min-h-[50px] flex justify-center items-center text-white bg-primary text-lg font-semibold rounded-xl hover:bg-accent mt-7"
                            >
                                {loading ? <div className="loader"></div> : "Save"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UserAdminForm;
